export default __webpack_public_path__ + "static/media/icons8-edit.b1ad66be.svg";